.theme-brand-signnow {
  .sn-call-to-action-type-3 {
    .call-to-action-type-2__content {
      overflow: hidden;
      border: 0;
      border-radius: map-get($border-radii, lg);
      background: $color-brand-primary-darkest;
      text-align: center;

      @include above($breakpoint-desktop-md) {
        text-align: left;
      }
    }

    .call-to-action-type-2__intro {
      padding: map-get($spacings, 2xl);
      color: $text-color-alternate;

      @include above($breakpoint-desktop-md) {
        padding: map-get($spacings, 6xl);
      }
    }

    .call-to-action-type-2__media {
      display: none;
      padding: map-get($spacings, 4xl) map-get($spacings, 4xl) map-get($spacings, 4xl) 0;

      @include above($breakpoint-desktop-md) {
        display: block;
      }
    }

    .me-text--label {
      text-transform: uppercase;
      letter-spacing: 3px;
      font-size: map-get($font-sizes, xs);
      font-weight: map-get($font-weights, bold);
    }

    .page-section__column--list {
      display: none;

      @include above($breakpoint-desktop-md) {
        display: block;
      }

      .picture {
        background-color: transparent;
      }
    }
  }
}
